import React from 'react';
import styled from 'styled-components';

const FlexWrap = styled.div`
        display:flex;
        align-items: center;
        margin-bottom:10px;
        & > div:first-child{
            color:#a72b2a;
            margin-right: 10px;
        }
        & > div{
            font-family: 'Noto Sans KR', sans-serif;
            font-weight: 700;
        }
    `;
function SectionTitle({ idx, children }) {
    return (
        <FlexWrap>
            <div>STEP{idx + 1}</div>
            <div>{children}</div>
        </FlexWrap>
    )
}


export default SectionTitle;